<div class="cnt-container">
  <input
    #qty
    type="number"
    [min]="min"
    [max]="max"
    [step]="step"
    [readonly]="readonly"
    [tabindex]="readonly ? -1 : 0"
    [formControl]="control"/>

  <div class="btn-container">
    <button class="up-btn"
            type="button"
            (click)="increment()"
            [disabled]="control.disabled || control.value === max"
            tabindex="-1">
      <img src="assets/icons/svg/arrow_up.svg"
           title="Quantity Up Arrow"
           alt="Quantity Up Arrow"
           aria-label="Quantity Up Arrow">
    </button>

    <button
      class="down-btn"
      type="button"
      (click)="decrement()"
      [disabled]="control.disabled || control.value <= min"
      tabindex="-1">
      <img src="assets/icons/svg/arrow_down.svg"
           title="Quantity Down Arrow"
           alt="Quantity Down Arrow"
           aria-label="Quantity Down Arrow">
    </button>
  </div>
</div>
